import axios from 'axios';
import { createSplitProducerQuery } from './queries';

const addSplitProducer = (model) =>
    new Promise((resolve, reject) => {
        const query = createSplitProducerQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add split producer'));
            });
    });

export default addSplitProducer;
